// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__3xb4t","modal":"style_modal__3g7-Z","content":"style_content__3FqVJ","footer":"style_footer__22kG0"};